import React, {useState, useEffect} from 'react';
import db from '../database'; // Import the PouchDB instance from your db.js file
import { Box, Typography, Link, Card, CardContent, Badge, Stack, Button, IconButton, CircularProgress} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {useParams} from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { green } from '@mui/material/colors';
const convertBlobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = function () {
        const base64Data = reader.result;
            resolve(base64Data)
        };

        reader.readAsDataURL(blob);
    })
}

function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

const CircularProgressWithLabel = ({count, total}) => {
   const percentage = (count/total) * 100
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" value={percentage} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="caption" component="div" sx={{color: 'white'}}>
          {`${count}/${total}`}
        </Typography>
      </Box>
    </Box>
  );
}


const exportSingleMeme = async (meme, img) => {
    const token = localStorage.getItem('storedValue')
    if (token) {
        const body = {
            user:'5cd5e839def20e39e7622b6a',
            title: meme.title,
            description: '',
            context: meme.context,
            tags: meme.tags,
            movie: meme.movie,
            language: meme.language,
            characters:meme.characters.filter(x=> x!==""),
            actors: meme.actors.filter(x=> x!==""),
            image: img
        }
        try {
            const response = await fetch('/api/post', {
                 method: "POST",
                headers: {
                  "Content-Type": "application/json",
                   "authorization": token 
                },
                body: JSON.stringify(body)
            })
            console.log('>', response.ok)
            if (response.ok) {
                const uploaded = await response.json()
                console.log(uploaded)
            } else {
                throw response.statusText
            }
        } catch (e) {
            throw e
            console.log(e)
        }
    }
}

const IndMeme = ({item, index, navigateToMemeDetail, handleDeleteMeme}) => {
    const [meme, setMeme] = useState()
    const [img, setImg] = useState()
    const getDoc = async (item) => {
        const doc = await db.get(item)
        const _img = await  db.getAttachment(doc._id, 'image')
        console.log(doc)
        setMeme(doc)
        setImg(_img)
    }
    useEffect(() => {
        if (item) {
            getDoc(item, { attachments: true })
        }
    }, [item])
    if (item) {
    return (
        <Card
        key={index}
        style={{
        margin: '8px',
        minWidth: '200px',
        maxWidth: '200px',
        cursor: 'pointer',
        alignSelf: 'flex-start'
        }}
        >
            <CardContent>
                {img && (<img onClick={navigateToMemeDetail(meme?._id)} src={URL.createObjectURL(img)} style={{width: '100%', height: 'auto'}}/>)}
                <Stack direction="row" alignItems="center">
                    <IconButton onClick={handleDeleteMeme(meme?._id)}>
                        <DeleteIcon/>                        
                    </IconButton>
                    {meme?.isUploaded && (<CheckCircleIcon sx={{color:green[500]}}/>)}
                </Stack>
            </CardContent>
        </Card>
    )
    } return null
}

const MovieHeader = ({name, language, count}) => {
    return (
        <Card>
          <CardContent sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            <Typography variant="h5" component="div">
              {name} ({language})
            </Typography>
            <Badge
                showZero
                badgeContent={count}
                color="primary"
                style={{ marginLeft: 15 }}
            >
            </Badge>
          </CardContent>
        </Card>
      );
}

const MemeList = () => {
    const [movie, setMovie] = useState([]);
    const [refreshData, setRefreshData] = useState(false)
    const [loading, setLoading] = useState(false)
    const [uploadedCount, setUploadedCount] = useState(0)
    const [confirming, setConfirming] = useState(false);
    const [cancelTimeout, setCancelTimeout] = useState(null);
    const [countdown, setCountdown] = useState(5); // Set your desired countdown time in seconds
    const {id} = useParams();

    const navigate = useNavigate();
    const navigateToMemeDetail = (_id) => {
        return ()=> {
            navigate(`/movie/${id}/meme/${_id}`)
        }
    }

    const startCountdown = () => {
        setCountdown(5); // Reset the countdown time
        const timeoutId = setTimeout(() => {
            setConfirming(false);
        }, countdown * 1000);
        setCancelTimeout(timeoutId);
    };

    const handleDeleteMeme = (_id) => {
        return async () => {
            try {
                const doc = await db.get(_id);
                await db.remove(_id, doc._rev);
                const movieDoc = await db.get(id)
                const _memes = [...movieDoc.memes]
                const delIndex = _memes.indexOf(_id)
                _memes.splice(delIndex, 1)
                movieDoc.memes = _memes
                await db.put(movieDoc)
                setRefreshData(true)
            } catch (e) {
                console.log(`could not delete`, e)
            }
        }
    }

    const handleExport = async() => {
        if (confirming) { 
            console.log(`exporting ${movie?.memes?.length} memes` )
            setUploadedCount(0)
            setLoading(true)
            for (const meme of movie.memes) {
                try {
                    const memeDoc = await db.get(meme, {_attachments:'true'})
                    const _img = await  db.getAttachment(memeDoc._id, 'image')
                    const base64Img = await convertBlobToBase64(_img)
                    await exportSingleMeme(memeDoc, base64Img)
                    memeDoc.isUploaded = true
                    await db.put(memeDoc)
                    setUploadedCount(_count => _count += 1)
                    await delay(2000)
                } catch (e) {
                    setLoading(false)
                    console.log(e)
                }
            }
            setLoading(false)
        } else {
            // First click, switch to confirming mode
            setConfirming(true);
            startCountdown();
        }
    }

    useEffect(()=>{
        db.get(id).then((result) => {
            setMovie(result)
        }).catch((error) => {
            setMovie(null)
            console.error('Error querying documents:', error);
        });
    }, [id, refreshData])

    useEffect(()=>{
        if (refreshData) {
            setRefreshData(false) 
            db.get(id).then((result) => {
                setMovie(result)
            }).catch((error) => {
                setMovie(null)
                console.error('Error querying documents:', error);
            });
        }
    }, [refreshData])

    useEffect(() => {
        return () => {
            clearTimeout(cancelTimeout);
        };
    }, [cancelTimeout]);

    if (movie) {
        return (
            <Stack sx={{marginTop:2, paddingTop:2, paddingRight:1, paddingLeft:1}}>

                    <MovieHeader name={movie?.title} language={movie?.language} count={movie?.memes?.length}/>
            {movie?.memes?.length> 0 && (
                <>
                <Box sx={{display:'flex', justifyContent: 'space-between', width: '100%', marginTop:4}}>
                    <Button onClick={()=>{navigate(`/`)}} variant="contained">Back</Button>
                    <Box sx={{display:'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Button sx={{marginRight: 2}} onClick={()=>{navigate(`/movie/${id}/meme/new`)}} variant="contained">Add New Meme</Button>
                        <Button
                            disabled={loading}
                            onClick={handleExport}
                            variant="contained"
                            endIcon={loading ? (<CircularProgressWithLabel count={uploadedCount} total={movie?.memes?.length}/>) : null}
                        >
                             {confirming ? `confirm` : 'Export'}
                        </Button>
                    </Box>
                    
                </Box>
                <Box sx={{width: '100%', display:'flex', flexWrap: "wrap"}}>
                {movie?.memes?.map((movie, i)=>(<IndMeme key={`movie-${i}`} item={movie} navigateToMemeDetail={navigateToMemeDetail} index={i} handleDeleteMeme={handleDeleteMeme}/>))}
                </Box>
                </>
            )}
            {movie?.memes?.length === 0 && (
                <Box sx={{marginTop:2}}>
                    <Typography>No Memes found</Typography>
                    <Link href={`/movie/${id}/meme/new`}>Click Here</Link> to add a meme or <Link href="/">go back</Link>
                </Box>
                )
            }
            </Stack>)
    }
    return (<Typography variant="h3">No Such Movie Found</Typography>)
    
}


export default MemeList
